<template>
	<div class="relative">
		<Search id="search" />
		<div id="map-selector">
			<div
				class="left"
				v-bind:class="{ active: map_type == 'custom' }"
				v-on:click="map_type = 'custom'"
			>
				Map
			</div>
			<div
				class="right"
				v-bind:class="{ active: map_type == 'satellite' }"
				v-on:click="map_type = 'satellite'"
			>
				Satellite
			</div>
		</div>

		<l-map
			:zoom="zoom"
			:bounds="bounds"
			:center="center"
			:options="{ zoomControl: false }"
			@click="map_click"
			:minZoom="2"
		>
			<l-tile-layer :url="map_url"></l-tile-layer>
			<l-control-zoom position="bottomright"></l-control-zoom>

			<!-- New location marker -->
			<l-marker
				v-if="new_location !== null"
				:lat-lng.sync="new_location.position"
				:draggable="true"
			>
				<l-icon :icon-size="[25, 25]">
					<div class="new-location-marker">
						<font-awesome-icon icon="map-marker-alt" class="active-color" />
					</div>
				</l-icon>
			</l-marker>

			<!-- Saved locations marker -->
			<l-marker
				v-for="(location, index) in locations"
				v-bind:key="'location_marker_' + index"
				:lat-lng.sync="location.position"
			>
				<l-popup :options="{ closeButton: false, className: 'map-tooltip' }">
					<div>
						<span>{{ location.name }}</span>
						<br />
						<span>{{ location.pv_category }}</span>
						<br />
						<span>Capacity {{ location.pv_data.peak_power }} MWp</span>
					</div>
				</l-popup>
				<l-icon :icon-size="[25, 25]">
					<div class="location-marker">
						<font-awesome-icon icon="map-marker" class="primary2-color" />
					</div>
				</l-icon>
			</l-marker>
		</l-map>
	</div>
</template>

<script>
import Search from "@/components/sub-components/Search";
import {
	LMap,
	LTileLayer,
	LControlZoom,
	LMarker,
	LIcon,
	LPopup
} from "vue2-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
const mapbox_data = require("@/config.js").mapbox;

//Fix marker icon bug: https://github.com/Leaflet/Leaflet/issues/4968#issuecomment-483402699
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
	iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
	iconUrl: require("leaflet/dist/images/marker-icon.png"),
	shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});

export default {
	name: "MainMap",
	components: {
		Search,
		LMap,
		LTileLayer,
		LControlZoom,
		LMarker,
		LIcon,
		LPopup
	},
	data() {
		return {
			map_type: "satellite",
			zoom: 3,
			zoomControl: false,

			//attribution:
			//	'&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
			new_location: null,
			center: [46.82355634774574, 14.98741149902344]
		};
	},
	methods: {
		remove_new_location: function() {
			this.new_location = null;
		},
		map_click: function(data) {
			//Remove markers
			this.new_location = [];
			//Add new marker
			this.new_location = {
				position: data.latlng
			};

			//Go to new location
			this.$router.push({
				name: "add-new",
				query: {
					lat: data.latlng.lat,
					lng: data.latlng.lng
				}
			});
		}
	},
	computed: {
		map_url: function() {
			const maps = {
				custom: mapbox_data.custom_map_url,
				satellite: mapbox_data.satellite_map_url
			};
			var result = maps[this.map_type] + "access_token=" + mapbox_data.token;
			return result;
		},
		locations: function() {
			return this.$store.getters.locations;
		},
		bounds: function() {
			var points = [];
			this.locations.forEach(location => {
				points.push(location.position);
			});
			return L.latLngBounds(points);
		}
	},
	mounted() {
		this.$root.$on("location_added", () => {
			this.remove_new_location();
		});

		this.$root.$on("new_location_sended", coordinates => {
			this.new_location = {
				position: coordinates
			};
			this.center = coordinates;
			this.zoom = 11;
		});
	}
};
</script>

<style>
#search {
	position: absolute;
	left: calc(50% - 200px);
	top: 35px;
	width: 400px;
	height: 30px;
	opacity: 0.9;
	border-radius: 27.5px;
	border: solid 1px #ffffff;
	background-color: #ffffff;
	z-index: 999;
	border: 3px solid var(--primary2);
}
#map-selector {
	position: absolute;
	background-color: white;
	top: 35px;
	right: 15px;
	z-index: 999;
	border-radius: 8px;
	padding: 5px 0;
}

#map-selector > div {
	padding: 5px 13px;
	color: #3a367b;
	font-weight: 500;
	cursor: pointer;
}
#map-selector > div.active {
	font-weight: bold;
}
#map-selector > div:first-child {
	border-right: 1px solid #d7d7d7;
}

/*.location-marker {
	width: 20px;
	height: 27px;
	margin-top: -28px;
	background-image: url("/icons/location_saved.png");
	background-repeat: no-repeat;
	background-size: 100% 100%;
}*/

.new-location-marker,
.location-marker {
	width: 30px;
	height: 42px;
	margin-top: -28px;
	font-size: 10px;
	font-size: 32px;
}
.location-marker {
	-webkit-filter: drop-shadow(0px 0px 5px rgba(255, 255, 255, 1));
	filter: drop-shadow(0px 0px 5px rgba(255, 255, 255, 1));
}
.map-tooltip {
	bottom: 35px !important;
}
.map-tooltip span:first-child {
	font-weight: bold;
	font-size: 16px;
}
.map-tooltip span:last-child {
	font-weight: 500;
	font-size: 13px;
}
</style>
